// The list's organisation, under its filters: "קבץ לפי" (none, its states, or one of its
// text columns) and "סדר" (as added, or by name) — saved on the list for everyone — and,
// when grouped, one chip per group to show that group alone. The group chip works with
// the state chips and the search, like they work with each other.
import he from '../../i18n/he';
import { toneClass } from './ListGlance';
import { groupChoices, groupingOf } from './listGroups';

const L = he.lists;

export default function ListGrouping({ list, onView, groupKey, onGroup }) {
  const grouping = groupingOf(list);
  const textColumns = list.columns.filter((c) => c.kind === 'text');
  const groupValue = grouping.mode === 'column' ? `c${grouping.column.id}` : grouping.mode;
  const choices = groupChoices(list);

  const setGroupBy = (v) => {
    onGroup(null);
    if (v === 'none' || v === 'state') onView({ group_by: v, sort: grouping.sort });
    else onView({ group_by: 'column', group_column_id: Number(v.slice(1)), sort: grouping.sort });
  };
  const setSort = (sort) => onView({
    group_by: grouping.mode,
    group_column_id: grouping.column ? grouping.column.id : null,
    sort,
  });

  return (
    <div className="list-grouping">
      <div className="list-grouping-row">
        <label className="list-pick">
          <span>{L.groupBy}</span>
          <select value={groupValue} onChange={(e) => setGroupBy(e.target.value)}>
            <option value="none">{L.groupNone}</option>
            <option value="state">{L.groupState}</option>
            {textColumns.map((c) => <option key={c.id} value={`c${c.id}`}>{c.label}</option>)}
          </select>
        </label>
        <label className="list-pick">
          <span>{L.sortBy}</span>
          <select value={grouping.sort} onChange={(e) => setSort(e.target.value)}>
            <option value="added">{L.sortAdded}</option>
            <option value="name">{L.sortName}</option>
          </select>
        </label>
      </div>
      {/* By state, the state chips above already are the group chips. */}
      {grouping.mode === 'column' && choices.length > 0 && (
        <div className="list-filters list-group-chips">
          <button type="button" className={`list-filter${groupKey ? '' : ' on'}`} onClick={() => onGroup(null)}>
            {L.allGroups} <b className="num">{list.items.length}</b>
          </button>
          {choices.map((g) => (
            <button
              key={g.key}
              type="button"
              className={`list-filter${g.tone ? ` ${toneClass(g.tone)}` : ''}${groupKey === g.key ? ' on' : ''}`}
              onClick={() => onGroup(groupKey === g.key ? null : g.key)}
            >
              {g.tone && <span className="dot" />}{g.label} <b className="num">{g.items.length}</b>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
